import axiosBase from "axios";

export default axiosBase.create({
  method: "GET",
  baseURL:
    process.env.NODE_ENV === "development"
      ? `http://${window.location.hostname}:5001/${process.env.VUE_APP_FIREBASE_PROJECT_ID}/asia-northeast1/`
      : `https://asia-northeast1-${process.env.VUE_APP_FIREBASE_PROJECT_ID}.cloudfunctions.net/`,
});
